/**
 * Emeter (Energy Meter) device template
 * Used by: Pro EM 50, Pro 3EM devices
 *
 * Emeters are monitoring-only devices with no control actions
 */

import {
	createPowerConsumptionCondition,
	createVoltageLevelCondition,
	createPowerThresholdTrigger,
} from '../../common/emeterMonitoring.js';

/**
 * Create emeter template
 * @param {number} channelCount - Number of emeter channels (2 or 3)
 */
export function createEmeterTemplate(channelCount = 3) {
	const channels = Array.from({ length: channelCount }, (_, i) => `em:${i}`);

	return {
		deviceType: 'emeter',
		channels,
		actions: {}, // No actions - monitoring only
		conditions: {
			powerConsumption: createPowerConsumptionCondition(7360),
			voltageLevel: createVoltageLevelCondition(265),
		},
		triggers: {
			powerThresholdCrossed: createPowerThresholdTrigger(7360),
		},
	};
}
